import { SET_GDPR_FEATURE_ALERT } from 'actions/ActionTypes';

const INITIAL_STATE = {
    displayGdprLimitedFeatureAlert: true
};

// ======= Handlers =======
const setGdprLimitedFeatureAlert = (state, action) => {
    return {
        displayGdprLimitedFeatureAlert: action.display
    };
};

// ======= Handler Assignments =======
const handlers = {
    [SET_GDPR_FEATURE_ALERT]: setGdprLimitedFeatureAlert
};

// ======= Default Action =======
export default function gdprDisplayLimitedFeatureAlert(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}

// ======= Actions =======
export function setGdprLimitedFeaturesAlert(display) {
    return {
        type: SET_GDPR_FEATURE_ALERT,
        display: display
    };
}

// ======= Selectors =======
export const getGdprLimitedFeatureAlert = (state) => {
    return state.gdprDisplayLimitedFeatureAlert.displayGdprLimitedFeatureAlert;
};
